import React from 'react';

interface WeeklyGoalWidgetProps {
  current: number;
  target?: number;
}

const WeeklyGoalWidget: React.FC<WeeklyGoalWidgetProps> = ({ current, target = 5 }) => {
  const progress = Math.min(Math.round((current / target) * 100), 100);
  const remaining = Math.max(target - current, 0);

  return (
    <div className="p-4 md:p-5 bg-black rounded-2xl text-white shadow-sm dark:bg-gray-800">
      <div className="flex items-center justify-between mb-3">
        <span className="text-xs md:text-sm font-bold">Weekly Goal</span>
        <span className="text-xs md:text-sm font-medium text-gray-400 dark:text-gray-500">{progress}%</span>
      </div>
      <div className="w-full bg-gray-800 rounded-full h-2 mb-3 dark:bg-gray-700">
        <div 
          className="bg-white h-2 rounded-full transition-all duration-500 dark:bg-teal-500"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <p className="text-[10px] md:text-xs text-gray-400 dark:text-gray-500">
        {remaining > 0 
          ? `${remaining} more collaborations to reach your target`
          : "You've reached your weekly target! 🎉"}
      </p>
    </div>
  );
};

export default WeeklyGoalWidget;
